import React from 'react';
const BusinessExecTab = () => React.createElement("span", { className: "sirius-icon sirius-icon-businessExec" });
BusinessExecTab.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-businessExec sirius-icon-businessExec-enhance" });
export default BusinessExecTab;
